import { sidebarConfig, SidebarExpandButton, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
    height: 2.4 * sidebarConfig.logoHeight,
    display: 'flex',
    alignItems: 'center',
    paddingRight: 8,
    boxSizing: 'border-box',
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
  expandButtonWrapper: {
    position: 'absolute',
    right: 2,
    top: '35%',
    transform: 'translateY(-100%)',
    zIndex: 10, // Assicura che sia sopra al logo
  },
});

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>

      <div className={classes.expandButtonWrapper}>
        <SidebarExpandButton />
      </div>
    </div>
  );
};